<template>
    <div>
        <!-- <my-multiselect
            v-model="language_select"
            ref="language"
            name="language"
            :options="languages_list"
            label="name"
            track-by="id"
            @input="changeLanguage"
        /> -->
        <div></div>
        <div class="lang ml-2" @click="language_enable = true">
            <masked-image src="/img/icons/ico_language.svg"></masked-image>
            {{ language_select }}
        </div>

        <div class="lang-modale" v-if="language_enable">
            <div class="header">
                <div class="title">
                    <masked-image src="/img/icons/ico_language.svg"></masked-image> {{ $root.lang.words.languages.choose }}
                </div>
                <div class="close" @click="language_enable = false">
                    <img src="/img/icons/clear.svg">
                </div>
            </div>
            <div class="languages">
                <div
                    v-for="(language, index) in languages"
                    :key="index"
                    :class="language == language_select ? 'selected' : ''"
                    @click="changeLanguage(language)"
                >
                   <div>
                        <img :src="'/img/icons/' + $root.lang.words.languages[language] + '.png'" width="17">
                    </div>
                    {{ $root.lang.words.languages[language] }}
                </div>
            </div>
            <span class="triangle"></span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            languages: {
                type: Array,
                required: true,
            }, 
        },
        
        data() {
            return {
                language_enable: false,
                language_select: window.language,
                languages_list: []
            }
        },

        created() {
            this.languages.forEach(element => {
                this.languages_list.push({
                    id: element,
                    name: this.$root.lang.words.languages[element]
                })
            })
        },

        methods: {
            changeLanguage(language) {
                // axios.post('/api/language/change/' + this.language_select)
                axios.post('/api/language/change/' + language)
                    .then((response) => {
                        // axios.get('/lang_nocache').then((response) => {
                            location.reload()
                        // })
                    })
                    .catch((error) => {
                        //
                    })
            }
        }
    }
</script>
